import type { GuidedView } from "./guided-views.js";
import { isGuidedView } from "./guided-views.js";

export interface GuidedRouteState {
  readonly view: GuidedView;
  readonly projectId: string | null;
  readonly startMethod: "agency" | "intake" | null;
}

export function parseGuidedRoute(search: string): GuidedRouteState {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  let view = params.get("view") ?? "home";
  if (view === "today") {
    view = "home";
  }
  const mode = params.get("mode");
  return {
    view: isGuidedView(view) ? view : "home",
    projectId: params.get("project")?.trim() || null,
    startMethod: mode === "intake" ? "intake" : mode === "agency" ? "agency" : null,
  };
}

export function buildGuidedSearch(input: {
  readonly view: GuidedView;
  readonly projectId?: string | null;
  readonly startMethod?: "agency" | "intake" | null;
}): string {
  const params = new URLSearchParams();
  if (input.view !== "home") {
    params.set("view", input.view);
  }
  if (input.projectId) {
    params.set("project", input.projectId);
  }
  if (input.view === "new" && input.startMethod) {
    params.set("mode", input.startMethod);
  }
  const q = params.toString();
  return q.length > 0 ? `?${q}` : "";
}

export function pushGuidedRoute(input: {
  readonly view: GuidedView;
  readonly projectId?: string | null;
  readonly startMethod?: "agency" | "intake" | null;
}): void {
  const search = buildGuidedSearch(input);
  const url = `${window.location.pathname}${search}${window.location.hash}`;
  window.history.pushState(null, "", url);
}
